import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import CookiePolicy from "@/pages/CookiePolicy";

export const Route = createFileRoute("/cookie-policy")({
  component: CookiePolicyRoute,
});

function CookiePolicyRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <CookiePolicy />
      </Suspense>
    </PageTransition>
  );
}
